export const routes = {
  main: "/",
  audience: "/audience",
  signIn: "/signin",
  signUp: "/signup",
} as const;
